import type { FC, SVGAttributes } from 'react';
import React from 'react';

export const IconSuccess: FC<SVGAttributes<SVGElement>> = props => (
    <svg height="18" viewBox="0 0 18 18" width="18" {...props}>
        <path d="M18 9A9 9 0 100 9a9 9 0 0018 0z" fill="#13A463" />
        <path
            d="M7.977 10.815l-3.07-2.912-.998.892 4.068 4.069 6.319-6.319-1.073-.98-5.246 5.25z"
            fill="#fff"
        />
    </svg>
);
